module.exports = "https://deal-img.imgix.net/consumer/modern/ibiza.8ebb50e5.jpg";